(function () {
    var image = $('.jarallax-img');
    if (!image) return;

    var options = {
        disableParallax: /iPad|iPhone|iPod|Android/,
        disableVideo: /iPad|iPhone|iPod|Android/,
        speed: 0.1,
    };

    image.imagesLoaded(function () {
        image.parent().jarallax(options).addClass('initialized');
    });
})();

(function () {
    'use strict';
    $('.featured-posts').owlCarousel({
        dots: false,
        margin: 30,
        nav: true,
        navText: [
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="18" height="18" fill="currentColor"><path d="M20.547 22.107L14.44 16l6.107-6.12L18.667 8l-8 8 8 8 1.88-1.893z"></path></svg>',
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="18" height="18" fill="currentColor"><path d="M11.453 22.107L17.56 16l-6.107-6.12L13.333 8l8 8-8 8-1.88-1.893z"></path></svg>',
        ],
        responsive: {
            0: {
                items: 1,
                slideBy: 1,
            },
            768: {
                items: 3,
                slideBy: 3,
            },
            992: {
                items: 4,
                slideBy: 4,
            },
        },
    });
})();

(function () {
    tocbot.init({
        tocSelector: '.js-toc',
        contentSelector: '.gh-content',
        headingSelector: 'h1, h2, h3'
      });
})();

(function () {
    const clipboard  = new ClipboardJS('.js-copy-link');
    const copyNotification = document.querySelector('.js-notification-copy-link');
    clipboard.on('success', function(e) {
        copyNotification.classList.add('visible');
        setTimeout(function(){
            copyNotification.classList.remove('visible');
        }, 10000);
        e.clearSelection();
    });
})();

(function () {
    const formNotifications=document.querySelectorAll('.form-notification');
    formNotifications.forEach(function(notification){
        const closeBtn = notification.querySelector('.notification-close');
        closeBtn.addEventListener('click', function() {
            document.querySelectorAll('[data-members-form]').forEach(function(el){
                el.classList.remove('success');
                el.classList.remove('error');
            })
        })
    });
})();
